import { Flex, Text } from '@chakra-ui/react';
import { ColorPicker } from 'modules/Editor/components/ColorPicker';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetType } from 'types/widget.types';
import { useSideMenuSetting } from 'widgets/sdk';

import { SeriesColorPickerProps } from './SeriesColorPicker.types';

const SeriesColorPicker = memo(({ label, series, onChange, chartType }: SeriesColorPickerProps) => {
  const { t } = useTranslation('editor_side_menu_settings', { useSuspense: false, keyPrefix: 'chartSettings' });
  const { setAllowScrolling } = useSideMenuSetting();
  // For scatter bubble charts, only one series color is used, until multi-series scatter bubble charts with category columns is supported.
  const seriesMap = chartType === WidgetType.ScatterBubbleChart ? [series[0]] : series;
  return (
    <>
      <Text mb={2} fontSize='sm'>
        {label}
      </Text>
      {!!seriesMap[0] &&
        seriesMap.map(({ color, name }, index: number) => {
          const onChangeDataColor = (color: string) => onChange(color, index);
          return (
            <Flex align='center' key={index}>
              <ColorPicker
                color={color}
                onChange={onChangeDataColor}
                onOpen={setAllowScrolling.off}
                onClose={setAllowScrolling.on}
                placement='left-start'
                label={t('colorPickerAriaLabel', { label, category: name })}
              />
              <Text pl={3} fontSize='sm'>
                {name}
              </Text>
            </Flex>
          );
        })}
    </>
  );
});
SeriesColorPicker.displayName = 'SeriesColorPicker';

export default SeriesColorPicker;
